import { render, staticRenderFns } from "./ServicesReservationAddClient.vue?vue&type=template&id=395c9744&scoped=true&"
import script from "./ServicesReservationAddClient.vue?vue&type=script&lang=js&"
export * from "./ServicesReservationAddClient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "395c9744",
  null
  
)

export default component.exports